import axios from 'axios';

export default function TabLogin(props) {
  function checkLogin(formData){
    axios.post(process.env.REACT_APP_BASE_URL+'auth/login',{Username:formData.get('email'),Password:formData.get('password')})
      .then(response => {
        let SessionKey=response.data.SessionKey;
        axios.defaults.headers.common['SessionKey'] = SessionKey;
        //get the user id
        axios.post(process.env.REACT_APP_BASE_URL+'auth/validate')
        .then(response => {
          let UserId=String(response.data.UserId);
          let Expiry=String(response.data.ExpiryTimestamp);
          localStorage.setItem('sessionExpiry', JSON.stringify(Expiry));
          //get the user
          axios.post(process.env.REACT_APP_BASE_URL+'get/user/'+UserId)
            .then(response => {
              let userType=response.data.definition.app_type;
              let userOptions={
                packlist: response.data.definition.app_packlist,
                refill: response.data.definition.app_refill
              };
              let UserObject={
                  id: response.data.id,
                  firstName: response.data.definition.first_name,
                  lastName: response.data.definition.last_name,
                  email: response.data.definition.email
                };
              props.onSetSessionUser(UserObject);
              localStorage.setItem('sessionUser', JSON.stringify(UserObject));
              props.onSetSessionKey(SessionKey);
              localStorage.setItem('sessionKey', JSON.stringify(SessionKey));
              props.onSetUserType(userType);
              localStorage.setItem('userType', JSON.stringify(userType));
              props.onSetUserOptions(userOptions);
              localStorage.setItem('userOptions', JSON.stringify(userOptions));
              switch(userType){
                case 'tech':
                  props.onGetTechData(null);
                  break;
                default:
                  props.onGetTourData(null);
                  break;
              }
              
            });
        });
      });
  }
  return (
    <div className="ui middle aligned center aligned grid">
      <div className="column" style={{maxWidth: "450px"}}>
        <h2 className="ui primary header">
          <div className="content">
            Login
          </div>
        </h2>
        <form className="ui large form" action={checkLogin}>
          <div className="ui segment">
            <div className="field">
              <div className="ui left icon input">
                <i className="user icon"></i>
                <input type="text" name="email" placeholder="E-mail address" />
              </div>
            </div>
            <div className="field">
              <div className="ui left icon input">
                <i className="lock icon"></i>
                <input type="password" name="password" placeholder="Password" />
              </div>
            </div>
            <button type="submit" className="ui fluid large primary submit button">Login</button>
          </div>
        </form>
      </div>
    </div>
  );
}